// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0176389a","455":"38a95fe1","977":"a1435964"}[chunkId] + ".chunk.js";
};